import styled from 'styled-components';

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyleFormWrapper = {
  MainContainer,
  Form,
};

export default StyleFormWrapper;
